import React, {useEffect, useState} from "react";
import {useLoggedInApi} from "../../api";
import {toast} from "react-toastify";
import {Col, Row, Spinner} from "reactstrap";
import ChartProgressBar from "../../components/charts/chartProgressBar";
import {stringToColour} from "../util";
import {useQuery} from "react-query";

const DEFAULT_DATA = {
    lets_talk: 0,
    email: 0,
    inquire_today: 0
}


export default function MostClicked(props) {
    const api = useLoggedInApi()

    const query = useQuery(['salesperson', 'tracking_clicked_elements', props.filters], () => {
        const resource = api.resource('salesperson')
        return resource.getItem('tracking_clicked_elements', {
            params: props.filters
        }).then(response => response.data)
    })

    const data = query.isSuccess ? query.data : {}

    const customLabels = {
        lets_talk: "Let's Talk",
        inquire_today: "Inquire Today",
        email: "Send me an email",
        broker_url: "Broker URL",
        carousel: "Property Image Carousel",
        location: "Property Location",
        more_info: "Property More Info",
        sample_computation: "Property Sample Computation",
        visit: "Property Site Visit"
    }

    const customColors = {
        lets_talk: "#0C71C3",
        inquire_today: "#967126",
        email: "#8300E9"
    }

    return <>
        <Row className="mt-5">
            <Col className="pb-2">
                <h5>MOST CLICKED ELEMENTS</h5>
            </Col>
            <Col className="col-auto">
                { query.isLoading && <Spinner/>}
            </Col>
        </Row>

        <div className="border-bottom"/>

        <ChartProgressBar
            data={[
                ...Object.keys(data).map(k => {
                    const label = customLabels.hasOwnProperty(k) ? customLabels[k] : k
                    return {
                        label: !!label ? label.toUpperCase() : <i>UNKNOWN</i>,
                        value: data[k],
                        color: customColors.hasOwnProperty(k) ? customColors[k]: stringToColour(k)
                    }
                }).filter(row => !!row.value)
            ]}
        />
    </>
}